import { Link } from 'react-router-dom';
import { manhwaList } from '@/mocks/manhwa';

export default function PopularRanking() {
  const ranked = [...manhwaList]
    .sort((a, b) => (a.trending || 99) - (b.trending || 99))
    .slice(0, 10);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门排行
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            最受读者欢迎的韩国漫画排行榜
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {ranked.map((manhwa, index) => (
            <Link
              key={manhwa.id}
              to={`/article/${manhwa.slug}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${
                index < 3 ? 'bg-accent-500' : 'bg-background-200'
              }`}>
                <span className={`font-bold text-sm ${index < 3 ? 'text-background-50' : 'text-foreground-500'}`}>
                  {index + 1}
                </span>
              </div>

              <div className="w-12 h-16 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={manhwa.cover}
                  alt={manhwa.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {manhwa.title}
                </h3>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-foreground-500">{manhwa.author}</span>
                  <span className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700">
                    {manhwa.categoryName}
                  </span>
                </div>
              </div>

              <div className="flex flex-col items-end flex-shrink-0">
                <div className="flex items-center gap-1">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{manhwa.rating}</span>
                </div>
                <span className="text-xs text-foreground-400 mt-0.5">
                  {(manhwa.views / 10000).toFixed(1)}万阅读
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}